<template>
    <div>
        <SummaryBox
            class="w-100"
            :info="formattedPerformance"
            :title="$t('pdiWidget.totalAchieved')"
        />
    </div>
</template>

<script>
import { EventBuzz } from '@/main'
import { getPdiAverage } from './api'
import { decimalFormat } from '@/lib/utils'
import { SummaryBox } from '../components'

export default {
    components: { SummaryBox },
    props: {
        userId: {
            type: [String, Number],
            required: true,
        },
        periods: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            performance: 0,
        }
    },
    mounted() {
        this.getPdiAverage()
        EventBuzz.$on('update-pdi-summary', this.getPdiAverage)
    },
    methods: {
        getPdiAverage() {
            getPdiAverage(this.userId, this.periods).then(resp => {
                this.performance = resp.data.data
            })
        },
    },
    computed: {
        formattedPerformance() {
            if (this.performance == 0 || this.performance == null) {
                return '-'
            }
            return `${decimalFormat(this.performance)}%`
        },
    },
    watch: {
        userId() {
            this.getPdiAverage()
        },
        periods() {
            this.getPdiAverage()
        },
    },
}
</script>

<style>
.h-100 {
    height: 100%;
}
.remove-border-radius {
    border-radius: 0%;
}
.performance-container {
    width: 50%;
}
.container-border {
    border-right: 1px solid #c8ced3;
    border-bottom: 1px solid #c8ced3;
    -webkit-box-shadow: 0px 0px 0px 2px rgba(228, 228, 235, 0.3);
    -moz-box-shadow: 0px 0px 0px 2px rgba(228, 228, 235, 0.3);
    box-shadow: 0px 0px 0px 2px rgba(228, 228, 235, 0.3);
}
</style>
